export default __webpack_public_path__ + "static/media/sh2_5.e8626e11.jpg";